import { render, staticRenderFns } from "./ActiveQuestions.vue?vue&type=template&id=2c0f6c52&"
import script from "./ActiveQuestions.vue?vue&type=script&lang=js&"
export * from "./ActiveQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports